module.exports = __webpack_public_path__ + "06_short_gray.b67f51a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_short_gray.png
// module id = RnLX
// module chunks = 0